import { SprintActionTypes } from "./constants";

const INIT_STATE = {
    sprint_data: [],
    sprint_task: [],
    sprint_report: [],
    loading: true,
    added: null,
    updated: null,
    deleted: null,
    error: null,
};

const Sprint = (state = INIT_STATE, action) => {
    switch(action.type) {
        case SprintActionTypes.API_RESPONSE_SUCCESS:
            switch(action.payload.actionType) {
                case SprintActionTypes.GET_SPRINT_DATA:
                    return {
                        ...state,
                        sprint_data: action.payload.data.data,
                        totalData: action.payload.data.total,
                        error: null,
                        loading: false
                    }

                case SprintActionTypes.GET_SPRINT_BY_ID:
                    return {
                        ...state,
                        sprint_task: action.payload.data.data,
                        totalDataTask: action.payload.data.total,
                        loading: false,
                    }

                case SprintActionTypes.ADD_SPRINT_DATA:
                    return {
                        ...state,
                        added: action.payload.data,
                        loading: false,
                    }

                case SprintActionTypes.UPDATE_SPRINT_DATA:
                    return {
                        ...state,
                        updated: action.payload.data.data,
                        loading: false,
                    }

                case SprintActionTypes.DELETE_SPRINT_DATA:
                    const response = { deleted: action.payload.data.data.deleted, message: action.payload.data.message }
                    return {
                        ...state,
                        deleted: response,
                        loading: false
                    }

                case SprintActionTypes.GET_SPRINT_REPORT_DATA:
                    return {
                        ...state,
                        sprint_report: action.payload.data.data,
                        sprint_report_total: action.payload.data.total,
                        loading: false,
                    }

                default:
                    return { ...state };
            }

        case SprintActionTypes.API_RESPONSE_ERROR:
            switch(action.payload.actionType) {
                case SprintActionTypes.GET_SPRINT_DATA:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }

                case SprintActionTypes.GET_SPRINT_BY_ID:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false
                    }

                case SprintActionTypes.ADD_SPRINT_DATA:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }

                case SprintActionTypes.UPDATE_SPRINT_DATA:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }

                case SprintActionTypes.DELETE_SPRINT_DATA:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }

                case SprintActionTypes.GET_SPRINT_REPORT_DATA:
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }
                
                default:
                    return { ...state, error: null }
            }

        case SprintActionTypes.RESET_SPRINT_DATA:
            return { ...state, loading: false, added: null, updated: null, deleted: null, error: null }
        default:
            return { ...state, error: null }
    }
};

export default Sprint;